import { useMemo } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import classNames from "classnames"

import { UITypes } from "types"
import { ReactComponent as IconHide } from "assets/svg/eyeClosed.svg"
import { ReactComponent as IconShow } from "assets/svg/eyeOpened.svg"
import { ReactComponent as IconDrag } from "assets/svg/icon-dragg.svg"

import { isMobileDevice } from "utils/deviceDetection"

import styles from "./index.module.scss"

interface Props extends UITypes.TableHeaderCell {
  onVisibilityChange: (value: string) => void
}

export const DADItem = ({ name, title, visibility, onVisibilityChange }: Props) => {
  if (!name) return null

  const mobileDevice = useMemo(() => isMobileDevice(), [])
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: name })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const toggleVisibility = (e: React.PointerEvent) => {
    e.stopPropagation()
    onVisibilityChange(name)
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(!mobileDevice && attributes)}
      {...(!mobileDevice && listeners)}
      className={classNames(styles.draggableItem, {
        [styles.dragging]: isDragging,
      })}
    >
      <span className={styles.dragIcon} {...(mobileDevice && listeners)} {...(mobileDevice && attributes)}>
        <IconDrag />
      </span>
      <span className={classNames({ [styles.hidden]: !visibility })}>{title || name}</span>
      <span className={styles.toggleHide} onPointerDown={toggleVisibility}>
        {visibility ? <IconShow /> : <IconHide />}
      </span>
    </div>
  )
}
